export const dateFormatFocus = 'DD/MM/YYYY';
export const dateFormat_D = 'D MMMM YYYY';
export const longDateFormat = 'DD MMMM YYYY';
export const apiDateFormat = 'YYYY-MM-DD';
export const dateFormat_DD = 'DD MMM YYYY';
export const timeFormat = 'h.mma';
export const sortCodeRegEx = /(\d{2})(?=\d)/g;
export const paymentToAuthcolumns = [
	{
		title: 'Date',
		id: 'date',
		path: ['date'],
		sortDirection: 'asc',
	},
	{
		title: 'From',
		id: 'from',
		path: ['from'],
	},
	{
		title: 'To',
		id: 'to',
		path: ['to'],
	},
	{
		title: 'Amount',
		id: 'amount',
		path: ['amount'],
	},
	{
		title: 'Reference',
		id: 'reference',
		path: ['reference'],
	},
	{
		title: 'Status',
		id: 'status',
		path: ['status'],
	},
	{
		title: 'Options',
		id: 'options',
		path: ['options'],
		isHiddenForPrint: true,
	},
];

export const expiredPaymentsColumns = [
	{
		title: 'Date',
		id: 'date',
		path: ['date'],
	},
	{
		title: 'From',
		id: 'from',
		path: ['from'],
	},
	{
		title: 'To',
		id: 'to',
		path: ['to'],
	},
	{
		title: 'Amount',
		id: 'amount',
		path: ['amount'],
	},
	{
		title: 'Reference',
		id: 'reference',
		path: ['reference'],
	},
	{
		title: 'Recurring',
		id: 'frequency',
		path: ['frequency'],
	},
	{
		title: 'Ending',
		id: 'end_date',
		path: ['end_date'],
	},
	{
		title: 'Creator',
		id: 'creator_name',
		path: ['creator_name'],
	},
];

export const paymentFrequencyLabelMap = {
	WEEKLY: { label: 'Every week' },
	TWO_WEEKLY: { label: 'Every two weeks' },
	THREE_WEEKLY: { label: 'Every three weeks' },
	FOUR_WEEKLY: { label: 'Every four weeks' },
	MONTHLY: { label: 'Every month' },
	TWO_MONTHLY: { label: 'Every two months' },
	QUARTERLY: { label: 'Every three months' },
	BIANNUAL: { label: 'Every six months' },
	ANNUALLY: { label: 'Every year' },
};

export const BACS_CREDIT_CODE = 'BCR';
export const BACS_DEBIT_CODE = 'BDB';

export const TYPE_FASTER_PAYMENTS = 'FASTER_PAYMENTS';
export const TYPE_FPS = 'FPS';
export const TYPE_BACS_CREDIT = 'BACS_CREDIT';
export const TYPE_BACS_DEBIT = 'BACS_DEBIT';
export const TYPE_CHAPS_PAYMENTS = 'CHAPS_PAYMENTS';
export const TYPE_BACS = 'bacs';
export const TYPE_IFT = 'IFT';
export const TYPE_CHAPS = 'CHAPS';

// Payment Types for IFT
export const TYPE_IBFT = 'IBFT';
export const TYPE_IOOP = 'IOOP';
export const TYPE_IBBP = 'IBBP';

// Payment Types for CHAPS
export const TYPE_CBFT = 'CBFT';
export const TYPE_COOP = 'COOP';
export const TYPE_CIAT = 'CIAT';
export const TYPE_CBBP = 'CBBP';

// Payment Types for BACS
export const TYPE_BCR = 'BCR';
export const TYPE_BDB = 'BDB';

// Payment Types for FPS
export const TYPE_BFT = 'BFT';
export const TYPE_BBP = 'BBP';
export const TYPE_IAT = 'IAT';
export const TYPE_OOP = 'OOP';
export const TYPE_LFDP = 'LFDP';
export const TYPE_FDP = 'FDP';
export const TYPE_SO = 'SO';
export const TYPE_RFDP = 'RFDP';
export const TYPE_RPI = 'RPI';

export const CAPABILITY_TYPE_BACS = 'BACS';
export const CAPABILITY_TYPE_FASTER_PAYMENTS = 'FPS';
export const CAPABILITY_TYPE_IFT = TYPE_IFT;
export const CAPABILITY_TYPE_CHAPS = TYPE_CHAPS;

export const editByIdPaymentTypes = [TYPE_IFT, TYPE_CHAPS];

export const AUTHORISE_FINAL_APPROVAL_ERROR_CODE = '2002';

export const AUTHORISE_BUSINESS_CUTOFF_ERROR_CODE = '2001';

export const WHO_PAYS_TYPE_YOU = 'DEBT';
export const WHO_PAYS_TYPE_RECIPIENT = 'CRED';
export const WHO_PAYS_TYPE_SHARED = 'SHAR';
export const whoPaysMapping = [
	{
		id: WHO_PAYS_TYPE_YOU,
		label: 'You',
		type: 'paid by you',
	},
	{
		id: WHO_PAYS_TYPE_RECIPIENT,
		label: 'The Recipient',
		type: 'paid by payee',
	},
	{
		id: WHO_PAYS_TYPE_SHARED,
		label: 'Shared',
		type: 'shared',
	},
];

export const fxRatesType = {
	PRE_BOOKED_RATE: 'PRE_BOOKED_RATE',
};

export const TIMER_COUNT_LIMIT = 30;

export const environments = {
	dev: 'dev',
	int3: 'int3',
	local: 'local',
	nonprod: 'nonprod',
	production: 'production',
	sit6: 'sit6',
	unknown: 'unknown',
};
